/**
 * Admin SPA グローバル状態。
 *
 * SPA 全体で参照される最小限の状態を保持する。
 * - view: 現在表示中の画面
 * - filter: 一覧画面で選択中のフィルタ
 * - reservations: 一覧で取得済みの予約
 * - selected: 詳細画面で表示中の予約
 * - liffUserId: LIFF 経由で取得したオーナーの userId（admin/me で確認済み）
 *
 * リアクティブ更新は使わず、画面遷移のたびに render を呼び直す方針。
 */

import type { Filter, Reservation, View } from "./types";

export const state: {
  view: View;
  filter: Filter;
  reservations: Reservation[];
  selected: Reservation | null;
  liffUserId: string | null;
} = {
  view: "list",
  filter: "today",
  reservations: [],
  selected: null,
  liffUserId: null,
};
